// material-ui
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Stack,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";

import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

import { LocalizationProvider } from "@mui/x-date-pickers";
import * as Yup from "yup";
import { useFormik, Form, FormikProvider } from "formik";
// project imports
import CircularWithPath from "components/@extended/progress/CircularWithPath";
import { openSnackbar } from "api/snackbar";
// types
import { SnackbarProps } from "types/snackbar";
import { useAppDispatch } from "hooks";

import { Title } from "model/basicInfo";
import { addTitle, editTitle } from "store/actions/main/basicInfo/title";
import { CircularProgress } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
// constant
const getInitialValues = (customer: Title | null) => {
  if (customer) {
    return {
      name: customer.name || "",
      name_trans: customer.name_trans.ar || "",
      status: customer.status || false,
    };
  } else {
    return {
      name: "",
      name_trans: "",
      status: false,
    };
  }
};

// ==============================|| TITLE ADD / EDIT - FORM ||============================== //

const FormTitleAdd = ({
  customer,
  id,
  closeModal,
  fetchData,
  setLoading,
  loading,
}: {
  loading: any;
  setLoading: any;
  fetchData: any;
  id: number;
  customer: Title | null;
  closeModal: () => void;
}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const CustomerSchema = Yup.object().shape({
    name: Yup.string().required("English Name is required"),
    name_trans: Yup.string().required("Arabic Name is required"),
  });

  const formik = useFormik({
    initialValues: getInitialValues(customer!),
    validationSchema: CustomerSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (customer) {
          // Dispatch editCategories action if customer exists
          await dispatch(
            editTitle({
              id: customer.id || 0,
              data: {
                name: values.name,
                status: values.status,
                name_trans: {
                  ar: values.name_trans,
                },
              },
            })
          ).then((action) => {
            fetchData();
            if (action.type === "basicInfo/editTitle/fulfilled") {
              openSnackbar({
                open: true,
                message: "Title edited successfully",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "alert",
                alert: {
                  color: "success",
                },
              } as SnackbarProps);
              setSubmitting(false);
              closeModal();
            }
          });
        } else {
          // Dispatch create newCat action if no customer exists
          await dispatch(
            addTitle({
              name: values.name,
              status: values.status,
              name_trans: {
                ar: values.name_trans,
              },
            })
          ).then((action) => {
            fetchData();
            if (action.type === "basicInfo/addTitle/fulfilled") {
              openSnackbar({
                open: true,
                message: "Title added successfully",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "alert",
                alert: {
                  color: "success",
                },
              } as SnackbarProps);
              setSubmitting(false);
              closeModal();
            }
          });
        }
        closeModal();
      } catch (error) {
        console.error(error);
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    setFieldValue,
  } = formik;

  if (loading)
    return (
      <Box sx={{ p: 5 }}>
        <Stack direction="row" justifyContent="center">
          <CircularWithPath />
        </Stack>
      </Box>
    );
  console.log(customer, "title customer");
  return (
    <>
      <FormikProvider value={formik}>
        <LocalizationProvider>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <DialogTitle
              style={{
                textAlign: "center",
                fontSize: "22px",
                fontWeight: "bold",
                color: "rgb(22, 119, 255)",
                marginBottom: "10px",
              }}
            >
              {customer ? (
                <FormattedMessage id="Edit Title Details" />
              ) : (
                <FormattedMessage id="Add New Title" />
              )}
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ p: 2.5 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={5} mb={1}>
                  <Stack spacing={1}>
                    <InputLabel htmlFor="customer-name">
                      <FormattedMessage id="English Name" />
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="customer-name"
                      placeholder={intl.formatMessage({
                        id: "Enter English Name",
                        defaultMessage: "Enter English Name",
                      })}
                      {...getFieldProps("name")}
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Stack>
                </Grid>
                <Grid item md={1} />
                <Grid item xs={12} sm={5}>
                  <Stack spacing={1}>
                    <InputLabel htmlFor="customer-order">
                      <FormattedMessage id="Arabic Name" />{" "}
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="customer-order"
                      placeholder={intl.formatMessage({
                        id: "Enter Arabic Name",
                        defaultMessage: "Enter Arabic Name",
                      })}
                      {...getFieldProps("name_trans")}
                    />
                  </Stack>
                </Grid>
                <Grid item md={1} />
                <Grid item xs={12} md={5}>
                  <Stack spacing={1}>
                    <InputLabel htmlFor="customer-is_active">
                      <FormattedMessage id="Status" />
                    </InputLabel>
                    <FormControl fullWidth>
                      <FormControlLabel
                        control={
                          <Switch
                            id="customer-is_active"
                            checked={formik.values.status}
                            {...getFieldProps("status")}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setFieldValue("status", checked);
                            }}
                          />
                        }
                        label={
                          formik.values.status ? (
                            <FormattedMessage id="active" />
                          ) : (
                            <FormattedMessage id="inactive" />
                          )
                        }
                      />
                    </FormControl>
                    {touched.status && errors.status && (
                      <FormHelperText
                        error
                        id="standard-weight-helper-text-email-login"
                        sx={{ pl: 1.75 }}
                      >
                        {errors.status}
                      </FormHelperText>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 2.5 }}>
              <Grid container justifyContent="center" alignItems="center">
                <Stack direction="row" spacing={2} sx={{ width: 1 }}>
                  <Grid item md={2} />
                  <Grid item md={4}>
                    {customer ? (
                      <Button fullWidth type="submit" variant="contained">
                        {isSubmitting ? (
                          <CircularProgress
                            size="1.5rem"
                            style={{ color: "white" }}
                          />
                        ) : (
                          <FormattedMessage id="Update" />
                        )}
                      </Button>
                    ) : (
                      <Button fullWidth type="submit" variant="contained">
                        {isSubmitting ? (
                          <CircularProgress
                            size="1.5rem"
                            style={{ color: "white" }}
                          />
                        ) : (
                          <FormattedMessage id="Submit" />
                        )}
                      </Button>
                    )}
                  </Grid>
                  <Grid item md={4}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="outlined"
                      onClick={closeModal}
                    >
                      <FormattedMessage id="Cancel" />
                    </Button>
                  </Grid>
                  <Grid item md={2} />
                </Stack>
              </Grid>
            </DialogActions>
          </Form>
        </LocalizationProvider>
      </FormikProvider>
    </>
  );
};

export default FormTitleAdd;
